<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link v-if="authenticated" to="/login" @click.native="logout" replace>Logout</router-link>
    </div> -->
    <router-view @authenticated="setAuthenticated" :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      authenticated: false
    }
  },
  mounted () {
    this.$store.dispatch('checkUserStatus')
  },
  computed: {
    userIsLogged () {
      let user = this.$store.getters.user || localStorage.getItem('user')
      if (user) {
        this.setAuthenticated(true)
      } else {
        this.setAuthenticated(false)
        let currentRoute = this.$router.currentRoute
        this.$router.replace({ name: currentRoute.name })
      }
      return user
    }
  },
  watch: {
    userIsLogged (value) {
      if (value === null || value === undefined) {
        this.setAuthenticated(false)
      }
    },
    authenticated (value) {
      if (value === false) {
        this.$router.replace({ name: 'login' })
      }
    }
  },
  methods: {
    setAuthenticated (status) {
      this.authenticated = status
    },
    logout () {
      if (this.authenticated) {
        this.$store.dispatch('userLogout')
        this.setAuthenticated(false)
      }
    }
  }
}
</script>

<style>
  .img-responsive, .full-width { width: 100%; }
  .photoURL {
    background-size: cover;
    background-position: center;
  }
  .img-coin:hover, .img-banknote:hover {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue